module.exports = __webpack_public_path__ + "static/docsComments-7d1016f8ae51c5f75e2e32b3f690ac81.png";